var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"last-step-container",class:{'no-stepper':_vm.isIterating}},[(!_vm.isIterating)?_c('Stepper',{staticClass:"stepper",attrs:{"steps":_vm.stepsCp,"current":_vm.steps.length},on:{"change":_vm.gotoStep}}):_vm._e(),_c('div',{staticClass:"step-content"},[_c('CampaignSetup',{attrs:{"game":_vm.game,"genres":_vm.game.genres}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }